export const useCardFormErrors = {
  INVALID_CARDHOLDER_NAME: 'Please enter the cardholder name',
  INVALID_CARD_NUMBER: 'Please enter a valid card number',
  INVALID_EXPIRATION_DATE:
    'Please enter the expiration date as it appears on your card',
  INVALID_CVC: 'Please enter the CVC or CVV number as it appears on your card',
  INVALID_ZIP_CODE: 'Please enter a valid zip or postal code',
};
